/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_SubmitInputs */



/**
* | output |
* | --- |
* | "Send" |
*
* @param {Feedback_SubmitInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const feedback_submit = /** @type {((inputs?: Feedback_SubmitInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_SubmitInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Envoyer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Enviar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Enviar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Invia")
	return /** @type {LocalizedString} */ ("Send")
});